import { Routes } from '@angular/router'
import { authGuard, preventLoginForAuthenticatedUserGuard } from './auth.guard'

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/components/user-account/login/login.component').then(
        (m) => m.LoginComponent
      ),
    canActivate: [preventLoginForAuthenticatedUserGuard],
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./auth/pia-callback/pia-callback.component').then((m) => m.PiaCallbackComponent),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/components/home/home.component').then((m) => m.HomeComponent),
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '/login' }, // TODO: create 404 page
]
